import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../SelectValue/FormikControl'
import Button from '../SelectValue/Button'
import { useNavigate } from 'react-router-dom'
import { addMonths } from 'date-fns'
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function SavingStart() {
  const navigate = useNavigate()
  const [startToday, setStartToday] = useState(false)

  const initialValues = {
    name: null,
  }

  const validationSchema = Yup.object({})

  const onSubmit = values => {
    let finalDate;
    if (startToday) {
      finalDate = new Date();
    } else if (values.name) {
      finalDate = values.name;
    } else {
      toast.error('Please select a start date option', {
        position: toast.POSITION?.TOP_RIGHT || "top-right"
      });
      return;
    }

    sessionStorage.setItem('startDate', finalDate)
    navigate('/save/plan/long')
  }

  return (
    <div className=''>
      <div className=' h-[60vh] '>
        <p className=' text-[18px] text-back-color2 mb-5 font-[500]'>When will you like to start?</p>

        <div className='mt-5'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {formik => (
              <Form>
                <div className=' flex mb-4  justify-between gap-3'>
                  <div className=' pt-2'>
                    <p className=' text-back-color2 text-[16px]'>I’ll start today</p>
                  </div>
                  <FormControlLabel 
                    control={
                      <Radio  
                        checked={startToday}
                        onClick={() => {
                          setStartToday(true);
                          formik.setFieldValue('name', null);
                        }}
                        sx={{
                          '&, &.Mui-checked': {
                            color: '#00BC67',
                          },
                        }}
                      />
                    }
                    label=""
                  />
                </div>

                <div onClick={() => setStartToday(false)}>
                  <FormikControl
                    control='date'
                    label='Set preferred date'
                    name='name'
                    minDate={new Date()}
                    maxDate={addMonths(new Date(), 12)}
                    showIcon
                    showDisabledMonthNavigation
                    placeholderText='DD/MM/YYYY'
                    showDropdownIcon={true}
                  />
                </div>
                
                <div className=' grid grid-cols-1 mb-5 mt-16'>
                  <Button
                    name='Next'
                  />
                </div>

              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default SavingStart